import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { InspectionDesign, Planner } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-certificate-planning',
  templateUrl: './certificate-planning.component.html',
  styleUrls: ['./certificate-planning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificatePlanningComponent implements OnInit {
  @Input() planner: Planner;
  @Input() inspection: InspectionDesign;

  notes: string[] = [];

  constructor() {}

  ngOnInit(): void {
    this.notes = new InspectionDesign(this.inspection)
      .getNotes()
      .filter((note) => note.addNotesToReport && note.notes)
      .filter((note) => !note.notes.includes('undefined'))
      .map((note) => note.notes);
  }
}
